import { useContext } from 'react';
import { NotificationContext } from './NotificationProvider';

/**
 * Hook to access notification functionality.
 * Must be used within a NotificationProvider.
 *
 * @example
 * const { promptNotification } = useNotification();
 * promptNotification({ message: 'Success!', status: 'success' });
 */
export function useNotification() {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
}
//# sourceMappingURL=useNotification.js.map